// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.articlesearch', {
        url: '/stockarticles?currentPage&filter&pageSize&inactive&match',
        views: {
            'articleList@stock': {
                templateUrl: 'main/stock/articles/articles.tpl.html',
                controller: 'StockArticlesController as vm'
            }
        },
        resolve: {
            articles: articlesResolver,
            isModelInventory: function() { return false; },
            isOrderingPoints: function() { return false; },
            searchTerms: searchTermResolver
        }
    });

    $stateProvider.state('stock.modelinventorysearch', {
        url: '/modelinventory?currentPage&filter&pageSize&inactive&match',
        views: {
            'articleList@stock': {
                templateUrl: 'main/stock/articles/articles.tpl.html',
                controller: 'StockArticlesController as vm'
            }
        },
        resolve: {
            articles: articlesResolver,
            isModelInventory: function() { return true; },
            isOrderingPoints: function() { return false; },
            searchTerms: searchTermResolver
        }
    });

    $stateProvider.state('stock.orderingpointssearch', {
        url: '/orderingpoints?currentPage&filter&pageSize&inactive&match',
        views: {
            'articleList@stock': {
                templateUrl: 'main/stock/articles/articles.tpl.html',
                controller: 'StockArticlesController as vm'
            }
        },
        resolve: {
            articles: articlesResolver,
            isModelInventory: function() { return false; },
            isOrderingPoints: function() { return true; },
            searchTerms: searchTermResolver
        }
    });
}

// @ngInject
function articlesResolver(StockApiService, $stateParams) {
    if (!$stateParams.currentPage || $stateParams.currentPage < 1) { $stateParams.currentPage = 1; }
    if (!$stateParams.filter) { $stateParams.filter = ''; }
    if (!$stateParams.pageSize || $stateParams.pageSize < 20) { $stateParams.pageSize = 20; }
    if (!$stateParams.inactive === undefined) { $stateParams.inactive = false; }
    if (!$stateParams.match === undefined) { $stateParams.match = false; }
    return StockApiService.getProducts($stateParams.currentPage, $stateParams.filter, $stateParams.pageSize, $stateParams.inactive, $stateParams.match);
}
// @ngInject
function searchTermResolver($stateParams) {
    return {
        filter: $stateParams.filter,
        currentPage: $stateParams.currentPage,
        pageSize: $stateParams.pageSize,
        inactive: $stateParams.inactive,
        match: $stateParams.match
    };
}
// @ngInject
function StockArticlesController($scope, $state, $stateParams, StockApiService, loadSpinnerService, articles, isModelInventory, isOrderingPoints, searchTerms) {
    var vm = this;

    //Properties
    vm.articles = articles.data.results;
    vm.filter = '';
    vm.currentPage = 1;
    vm.selectedArticleId = 0;
    vm.pageSize = 20;
    vm.pageSize = articles.data.total;
    vm.selectedArticleId = 0;
    vm.useElasticProductSearch = false;
    vm.match = false;
    vm.inactive = false;

    //Methods
    vm.selectArticle = selectArticle;
    vm.getSearchTooltipText = getSearchTooltipText;

    activate();

    function activate() {
        vm.filter = searchTerms.filter ? searchTerms.filter : '';
        vm.currentPage = searchTerms.currentPage > 1 ? searchTerms.currentPage : 1;
        vm.pageSize = searchTerms.pageSize >= 20 ? searchTerms.pageSize : 20;
        vm.match = searchTerms.match ? searchTerms.match == 'true' ? true : false : false;
        vm.inactive = searchTerms.inactive ? searchTerms.inactive == 'true' ? true : false : false;

        $scope.$watch(function onArticleIdWatch() {
        return $state.params.articleId;
    }, function onArticleIdChanged() {
        vm.selectedArticleId = parseInt($state.params.articleId, 10);
    });
    }

    function getSearchTooltipText() {
        var tooltipString = 'Sökning med partiella ord görs med en stjärna, ex. "Ja*" för "Jacka"';
        if (!vm.useElasticProductSearch) { tooltipString = ''; }

        return tooltipString;
    }

    function selectArticle(article) {
        if (isModelInventory) {
            $state.go('stock.modelinventorysearch.modelinventory', {
                articleId: article.articleId,
                filter: article.searchTerms.filter,
                currentPage: article.searchTerms.currentPage,
                pageSize: article.searchTerms.pageSize,
                inactive: article.searchTerms.inactive,
                match: article.searchTerms.match
            });
        } else if (isOrderingPoints) {
            $state.go('stock.orderingpointssearch.orderingpoints', {
                articleId: article.articleId,
                filter: article.searchTerms.filter,
                currentPage: article.searchTerms.currentPage,
                pageSize: article.searchTerms.pageSize,
                inactive: article.searchTerms.inactive,
                match: article.searchTerms.match
            });
        } else {
            $state.go('stock.articlesearch.article', {
                articleId: article.articleId,
                filter: article.searchTerms.filter,
                currentPage: article.searchTerms.currentPage,
                pageSize: article.searchTerms.pageSize,
                inactive: article.searchTerms.inactive,
                match: article.searchTerms.match
            });
        }
    }
}

angular
    .module('stock.articles', ['stock.articles.article', 'stock.articles.modelinventory', 'stock.articles.caArticleStocksHistory', 'stock.articles.articleStocksHistory'])
    .config(stateConfig)
    .controller('StockArticlesController', StockArticlesController);
